import { Dots, Typing } from "../ChatManager/ChatManagerStyles"


const TypingContainer = ({topp, rightt, mt, mb}) => {
    return (
                          <Typing  topp={topp} rightt={rightt} mt={mt} mb={mb}>
                           <span>writing</span>
                           <Dots>
                             <span>.</span>
                             <span>.</span>
                             <span>.</span>
                           </Dots>
                           </Typing>
    )
}

export default TypingContainer